export default __webpack_public_path__ + "static/media/search.3c65d373.svg";